import { connect } from 'react-redux';
import { getTitleFromBreadcrumb } from '@nykaa/seo/utils';
import { State } from 'store/types';
import View from './View';

const mapStateToProps = (state: State) => {
  const { footer, appReducer } = state;
  const { breadCrumb } = appReducer;
  const title = getTitleFromBreadcrumb(breadCrumb);
  return {
    title,
    categories: footer?.categories,
    pageType: appReducer?.pageType,
  };
};

export default connect(mapStateToProps)(View);
